import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { apiConnector } from '../../../services/apiconnector';
import { contactusEndpoint } from '../../../services/apis';
import CountryCode from "../../../data/countrycode.json"
import toast from 'react-hot-toast';

const ContactUsForm = () => {
    const [loading, setLoading] = useState(false);
    const {register, handleSubmit, reset, formState: {errors, isSubmitSuccessful}} = useForm();

    const submitContactForm = async(data)=>{
        const toastId = toast.loading("Loading...");
        try {
            setLoading(true);
            const response = await apiConnector("POST", contactusEndpoint.CONTACT_US_API, data);
            console.log("LOGGING CONTACT_US_API Response:", response);

            if(!response.data.success){
                throw new Error(response.data.message);
            }

            toast.success("Message sent successfully.");
            setLoading(false);
        } catch (error) {
            console.log(error);
            toast.error("Failed to send message");
            setLoading(false);
        }
        toast.dismiss(toastId);
    }

    useEffect(() => {
        if (isSubmitSuccessful) {
            reset({
                email: "",
                firstname: "",
                lastname: "",
                message: "",
                phoneNo: "",
            });
        }
    }, [reset, isSubmitSuccessful]);


  return (
    <form onSubmit={handleSubmit(submitContactForm)} className="flex flex-col gap-7">
        {/* first name/ last name */}
        <div className="flex flex-col gap-5 lg:flex-row">
            <div className="flex flex-col gap-2 lg:w-[48%]">
                <label htmlFor="firstname" className="lable-style">
                    First Name
                </label>
                <input 
                    type="text" 
                    name='firstname' 
                    id='firstname' 
                    placeholder='Enter first name' 
                    className='form-style' 
                    {...register("firstname", {required:true})}
                />
                {errors.firstname && (
                    <span className="-mt-1 text-[12px] text-yellow-100">
                    Please enter your first name.
                    </span>
                )}
            </div>
            <div className="flex flex-col gap-2 lg:w-[48%]">
                <label htmlFor="lastname" className="lable-style">
                    Last Name
                </label>
                <input 
                    type="text" 
                    name='lastname' 
                    id='lastname' 
                    placeholder='Enter first name' 
                    className='form-style' 
                    {...register("lastname", {required:true})}
                />
                {errors.lastname && (
                    <span className="-mt-1 text-[12px] text-yellow-100">
                    Please enter your last name.
                    </span>
                )}
            </div>
        </div>
        
        {/* email */}
        <div className="flex flex-col gap-2">
            <label htmlFor="email" className="lable-style">
                Email Address
            </label>
            <input
                type="email"
                name="email"
                id="email"
                placeholder="Enter email address"
                className="form-style"
                {...register("email", { required: true })}
            />
            {errors.email && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                    Please enter your Email address.
                </span>
            )}
        </div>

        {/* phone no */}
        <div className="flex flex-col gap-2">
            <label htmlFor="phonenumber" className="lable-style"> Phone Number </label>
            <div className="flex gap-5">
                {/* dropdown */}
                <div className="flex w-[83px] flex-col gap-2">
                    <select name="dropdown" id="dropdown" {...register("countrycode", {required:true})} className="form-style cursor-pointer">
                        {
                            CountryCode.map((code, i)=>{
                                return(
                                    <option value={code.code} key={i}>{code.code} -{code.country}</option>
                                )
                            })
                        }
                    </select>
                </div>

                {/* phone */}
                <div className="flex w-[calc(100%-90px)] flex-col gap-2">
                    <input type="number" name="phonenumber" id="phonenumber" className="form-style" placeholder='12345 67890'
                        {...register("phoneNo", {
                            required: {
                                value:true,
                                message: "Please enter your Phone Number.",
                            },
                            minLength:{ value: 10, message: "Invalid Phone Number" },
                            maxLength: { value: 12, message: "Invalid Phone Number" },
                        })}
                    />
                </div>
            </div>
            {errors.phoneNo && (
                <span className="-mt-1 text-[12px] text-yellow-100">{errors.phoneNo.message}</span>
            )}
        </div>

        {/* message box */}
        <div className="flex flex-col gap-2">
            <label htmlFor="message" className="lable-style">Message </label>
            <textarea
                name="message"
                id="message"
                cols="30"
                rows="7"
                placeholder="Enter your message here"
                className="form-style"
                {...register("message", { required: true })}
            />
            {errors.message && (
            <span className="-mt-1 text-[12px] text-yellow-100">
                Please enter your Message.
            </span>
            )}
        </div>

        <button type="submit" disabled={loading}
            className={`rounded-md bg-yellow-50 px-6 py-3 text-center text-[13px] font-bold text-black shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] 
                ${
                !loading && "transition-all duration-200 hover:scale-95 hover:shadow-none"
                } 
             disabled:bg-richblack-500 sm:text-[16px] `}
        >
            Send Message
        </button>
    </form>
  )
}

export default ContactUsForm
